<div (click)="navigate()" [class.success-bg]="($amountObservable | async) === 0" [class.regular-bg]="
        ((($amountObservable | async) ?? 0 > 0) &&
            !donationPrintDue &&
            (type === actionCardType.PRINT_PERMANENT || type === actionCardType.PRINT_SINGLE)) ||
        (type === actionCardType.IMPORT_DONATIONS && channels.length === 0)
    " class="card" [class.default]="
        (!canSendReceipts && (type === actionCardType.PRINT_PERMANENT || type === actionCardType.PRINT_SINGLE)) ||
        (type === actionCardType.IMPORT_DONATIONS && !canImportChannels)
    " fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
    <div class="icon" [class.regular]="
            (($amountObservable | async) ?? 0 > 0) &&
            (type === actionCardType.PRINT_PERMANENT || type === actionCardType.PRINT_SINGLE)
        ">
        <mat-icon *ngIf="
                (($amountObservable | async) ?? 0 > 0) &&
                type !== actionCardType.PRINT_PERMANENT &&
                type !== actionCardType.PRINT_SINGLE
            ">priority_high</mat-icon>

        <mat-icon color="primary" *ngIf="($amountObservable | async) === 0">check_circle</mat-icon>

        <div *ngIf="type === actionCardType.PRINT_PERMANENT">
            <mat-icon *ngIf="($amountObservable | async) ?? 0 > 0">file_copy</mat-icon>
        </div>

        <div *ngIf="type === actionCardType.PRINT_SINGLE">
            <mat-icon *ngIf="($amountObservable | async) ?? 0 > 0">insert_drive_file</mat-icon>
        </div>
    </div>
    <div id="title-caption-div">
        <h2 style="margin: 0px 16px 10px 0px" id="title">
            <span *ngIf="($amountObservable | async) !== -1 && type !== actionCardType.IMPORT_DONATIONS">{{
                $amountObservable | async
                }}</span>
            {{ title }}
        </h2>
        {{ caption }}
    </div>
    <mat-icon>chevron_right</mat-icon>

    <div *ngIf="type === actionCardType.IMPORT_DONATIONS" class="channels"
        [class.active]="($amountObservable | async) === 0">
        <div *ngFor="let channel of channels">
            <div fxLayout="row" fxLayoutGap="16px" class="channel">
                <div class="bold">{{ channel.name }}</div>
                <div *ngIf="channel.latestImport">Zuletzt: {{ channel.latestImport | dateToDateTimeString }}</div>
                <div *ngIf="!channel.latestImport">Zuletzt: nie</div>
            </div>
        </div>
    </div>
</div>